module.exports = __webpack_public_path__ + "img/SchlagtMichZumRitter.a47811c4.svg";